export var PathNames;
(function (PathNames) {
    PathNames["Unauthorized"] = "/UnauthorizedAccess";
    PathNames["Edit"] = "/edit";
    PathNames["Scenario"] = "/scenario";
    PathNames["Results"] = "/result-set";
    PathNames["Upload"] = "/upload";
    PathNames["ObjectForImport"] = "/object";
    PathNames["Workspaces"] = "/workspaces";
    PathNames["CellModels"] = "/cell-models";
    PathNames["Recipes"] = "/recipes";
    PathNames["ProcessData"] = "/process-data";
    PathNames["RecipeScaling"] = "/recipe-scaling";
    PathNames["PointScaling"] = "/point-scaling";
    PathNames["Import"] = "/import";
    PathNames["AdminPanel"] = "/admin-panel";
    PathNames["HelpCenter"] = "/help";
})(PathNames || (PathNames = {}));
export var PathProperties;
(function (PathProperties) {
    PathProperties["Id"] = "/:id";
    PathProperties["ListType"] = "/:listType";
})(PathProperties || (PathProperties = {}));
const MainRoutePaths = {
    Home: "/",
    Unauthorized: PathNames.Unauthorized,
    PointScalingWorkspaces: `${PathNames.PointScaling}${PathNames.Workspaces}`,
    PointScalingWorkspace: `${PathNames.PointScaling}${PathNames.Workspaces}${PathProperties.Id}`,
    RecipeScaling: PathNames.RecipeScaling,
    AdminPanel: PathNames.AdminPanel,
    Help: PathNames.HelpCenter,
};
const RecipeScalingListPaths = {
    // RecipeScalingLists
    RecipeScalingLists: `${PathNames.RecipeScaling}${PathProperties.ListType}`,
    // Workspace
    RecipeScalingWorkspaces: `${PathNames.RecipeScaling}${PathNames.Workspaces}`,
    ImportRecipeScalingWorkspace: `${PathNames.RecipeScaling}${PathNames.Workspaces}${PathNames.Import}`,
    RecipeScalingWorkspace: `${PathNames.RecipeScaling}${PathNames.Workspaces}${PathProperties.Id}`,
    EditRecipeScalingWorkspace: `${PathNames.RecipeScaling}${PathNames.Workspaces}${PathProperties.Id}${PathNames.Edit}`,
    // CellModel
    CellModels: `${PathNames.RecipeScaling}${PathNames.CellModels}`,
    CellModel: `${PathNames.RecipeScaling}${PathNames.CellModels}${PathProperties.Id}`,
    ImportCellModel: `${PathNames.RecipeScaling}${PathNames.CellModels}${PathNames.Import}`,
    EditCellModel: `${PathNames.RecipeScaling}${PathNames.CellModels}${PathProperties.Id}${PathNames.Edit}`,
    // Recipes
    Recipes: `${PathNames.RecipeScaling}${PathNames.Recipes}`,
    Recipe: `${PathNames.RecipeScaling}${PathNames.Recipes}${PathProperties.Id}`,
    EditRecipe: `${PathNames.RecipeScaling}${PathNames.Recipes}${PathProperties.Id}${PathNames.Edit}`,
    //ProcessData
    ProcessDatas: `${PathNames.RecipeScaling}${PathNames.ProcessData}`,
    ProcessData: `${PathNames.RecipeScaling}${PathNames.ProcessData}${PathProperties.Id}`,
};
const ProcessDataSubPaths = {
    ProcessDataUpload: `${RecipeScalingListPaths.ProcessDatas}${PathNames.Upload}`,
    ProcessDataObjectForImport: `${RecipeScalingListPaths.ProcessDatas}${PathNames.Upload}${PathNames.ObjectForImport}`,
};
const RoutePaths = {
    ...MainRoutePaths,
    ...RecipeScalingListPaths,
    ...ProcessDataSubPaths,
};
export default RoutePaths;
